'use client';
import Skeleton from '@/components/tools/skeleton/skeleton';

export default function OverviewLoading() {
  return (
    <>
      <Skeleton className="OverviewLoading" />
    </>
  );
}
